export default [
    {
        path: '/home',
        component: () => import('../components/pages/home/Home.vue') ,
        meta: {
            title: '主页'
        }
    }

]